import Icon from './Icon.jsx';

export default function PresentationChrome({
  slides,
  index,
  tone,
  onGo,
  onPrevious,
  onNext,
  fullscreen,
  onFullscreen,
}) {
  const current = slides[index];
  const logo = tone === 'dark' ? '/assets/logo-beige.svg' : '/assets/logo-primary.svg';

  return (
    <>
      <header className="topbar">
        <button className="brand-button" onClick={() => onGo(0)} aria-label="Return to the opening slide">
          <img src={logo} alt="Touch of Health Rehabilitation Center" />
        </button>
        <div className="experience-title">
          <span>{current.label}</span>
          <b>TOUCH OF HEALTH REHABILITATION CENTER</b>
        </div>
        <button className="topbar-action" onClick={onFullscreen} aria-label="Toggle fullscreen">
          <Icon name={fullscreen ? 'contract' : 'expand'} />
          <span>{fullscreen ? 'Exit' : 'Fullscreen'}</span>
        </button>
      </header>

      <nav className="chapter-rail" aria-label="Presentation slides">
        {slides.map((slide, slideIndex) => (
          <button
            key={slide.index}
            className={slideIndex === index ? 'is-active' : ''}
            onClick={() => onGo(slideIndex)}
            title={slide.label}
          >
            <span>{slide.index}</span>
            <b>{slide.label}</b>
            <i />
          </button>
        ))}
      </nav>

      <div className="presentation-controls">
        <button onClick={onPrevious} disabled={index === 0} aria-label="Previous slide">
          <Icon name="arrowLeft" />
        </button>
        <div className="scene-counter">
          <b>{String(index + 1).padStart(2, '0')}</b>
          <i />
          <span>{String(slides.length).padStart(2, '0')}</span>
        </div>
        <button onClick={onNext} disabled={index === slides.length - 1} aria-label="Next slide">
          <Icon name="arrow" />
        </button>
      </div>
    </>
  );
}
